export var TypeActionQuickSell;
(function (TypeActionQuickSell) {
    TypeActionQuickSell["Sell"] = "QuickSell > Sell";
    TypeActionQuickSell["Info"] = "QuickSell > Info";
})(TypeActionQuickSell || (TypeActionQuickSell = {}));
export var actionQuickSellResourceSell = function (itemId, amount) { return ({
    amount: amount,
    itemId: itemId,
    type: TypeActionQuickSell.Sell,
}); };
export var actionQuickSellResourceInfo = function (productInfo) { return ({
    productInfo: productInfo,
    type: TypeActionQuickSell.Info,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/quick-sell-dialog/actionQuickSell.ts
// module id = 352
// module chunks = 3